import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getPlant: () => {
		let url = `${BASE_URL}/cc/v1/plant`;
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	getCommCds: ({ plantCd, commCdType }) => {
		let url = `${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${commCdType}`;
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	getSchemas: ({ plantCd }) => {
		let url = `${BASE_URL}/table/v1/plants/${plantCd}/schemas`;
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	getAllSchemas: ({ plantCd }) => {
		let url = `${BASE_URL}/table/v1/plants/${plantCd}/allSchemas`;
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	getTableDataManagementList: ({ plantCd, schema, tableId, managed, currentPage, pageUnit }) => {
		let url = `${BASE_URL}/table/v1/plants/${plantCd}/tables?schema=${schema}&tableId=${tableId}&managed=${managed}&currentPage=${currentPage}&pageUnit=${pageUnit}`;
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	getUnmanagedTables: ({ plantCd, schema }) => {
		let url = `${BASE_URL}/table/v1/plants/${plantCd}/unmanagedTables?schema=${schema}`;
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	addTables: ({ plantCd, params }) => {
		let url = `${BASE_URL}/table/v1/status/1/plants/${plantCd}/tables/${params.tableId}`;
		return client
			.post(url, params)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	saveTables: ({ plantCd, params }) => {
		let url = `${BASE_URL}/table/v1/status/2/plants/${plantCd}/tables/${params.tableId}`;
		return client
			.post(url, params)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	delTables: ({ plantCd, params }) => {
		let url = `${BASE_URL}/table/v1/status/3/plants/${plantCd}/tables/${params.tableId}`;
		return client
			.post(url, params)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	mergePolicy: ({ plantCd, tableId, status, requestBody }) => {
		let url = `${BASE_URL}/table/v1/status/${status}/plants/${plantCd}/tables/${tableId}`;
		return client
			.post(url, requestBody)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	deletePolicy: ({ plantCd, tableId }) => {
		let url = `${BASE_URL}/table/v1/status/3/plants/${plantCd}/tables/${tableId}`;
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	}
};
